<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      香梅站<br><br>
站点介绍<br>
香梅站设于红荔西路与香梅路交叉口处，车站平行红荔西路东西向布置。站位周边为规划成熟区，车站北侧主要有香蜜湖、水榭花都、市政大夏、香蜜新村，车站南侧主要有市规划局、深圳土地房产交易大夏、中投国际商务中心、缇香名苑。香梅站装修设计采用格栅形式突出重点，天兰色基调。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:08	23:33	9号线	3分50秒	5分55秒<br>
文锦	06:26	23:35	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:07	23:33	9号线	4分25秒	5分55秒<br>
文锦	06:26	23:35	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:02	00:34	9号线	4分钟	5分55秒<br>
文锦	06:24	00:35	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A1出入口:<br>
红荔西路南侧（西）、香蜜南二街、规划大厦、深圳市海洋渔业局、深圳土地房产交易大厦、深圳市规划和自然资源局、深圳市林业局、深圳市城市更新和土地整备局<br><br>
A2出入口:<br>
香梅路西侧（南）、香蜜南四街<br><br>
B出入口:<br>
红荔西路南侧（东）、新闻路、景田派出所、景田南路街心公园、缇香名苑、香蜜二村、香逸名园<br><br>
C出入口:<br>
红荔西路北侧（东）、景田西路、市政大厦、鲁班大厦、市政大院、香蜜新村、深圳景田医院<br><br>
D出入口:<br>
香梅路西侧（北）、荔园外国语小学、水榭花都<br><br>
公交换乘信息<br><br>
A2出入口:<br>
公交站名： 香蜜二村<br>
21、215路、222路、M441、M392、M173、M555路、高快巴士25号<br><br>
B出入口:<br>
公交站名： 市政大厦2<br>
107路、215路、222路、316路、M555路<br><br>
C出入口:<br>
公交站名： 市政大厦<br>
107路、215路、21路、222路、316路、M173路、M555路<br><br>
D出入口:<br>
公交站名： 龙塘<br>
316路、328路、M392路、M441路、B666、高快巴士25号<br><br>
D出入口:<br>
公交站名： 水榭花都<br>
107路<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>